<template>
    <div class="Preview">
        <Header msg="我的学生"/>
        <div class="navbar">
            <Navbar :selected.sync="selected" :selecteData="selecteData" />
            <van-search
                v-model.trim="kw"
                :placeholder="`${selected === 0 ? '请输入姓名':'请输入姓名或手机号码'}`"
                show-action
                shape="round"
                @search="onSearch"
                style="height:0.5rem;">
                <div slot="action" @click="onSearch" style="color:#FABF01">搜索</div>
            </van-search>
        </div>
        
        <router-view/>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Navbar from '@/components/Navbar.vue';
import { Toast } from 'mint-ui';

export default {
    name: 'Preview',
    components: {
      Header,
      Navbar
    },
    data() {
      return {
        selected: 0, // Navbar索引
        selecteData: [{id: 1, name: '预报名单', num: 0}, {id: 2, name: '未支付', num: 0}, {id: 3, name: '已报名', num: 0}], // Navbar数据
        // selecteData: [{id: 2, name: '未支付', num: 0}, {id: 3, name: '已报名', num: 0}],
        kw: '' // 搜索词
      }
    },
    created() {
      switch (window.location.pathname) {
        case "/Preview/PreAdd":
          this.selected = 0;
          break;
        case "/Preview/PreNotRegistered":
          this.selected = 1;
          break;
        case "/Preview/PreEnrolled":
          this.selected = 2;
          break;
        default:
          break;
      }
      // switch (window.location.pathname) {
      //   case "/Preview/PreNotRegistered":
      //     this.selected = 0;
      //     break;
      //   case "/Preview/PreEnrolled":
      //     this.selected = 1;
      //     break;
      //   default:
      //     break;
      // }
    },
    mounted() {

    },
    methods: {
      onSearch() {
        this.handleRoute(this.selected);
      },
      handleRoute(val) {
        window.scrollTo(0, 0);
        switch (val) {
          case 0:
            this.$router.replace({path:`/Preview/PreAdd?kw=${this.kw}`});
            break;
          case 1:
            this.$router.replace({path:`/Preview/PreNotRegistered?kw=${this.kw}`});
            break;
          case 2:
            this.$router.replace({path:`/Preview/PreEnrolled?kw=${this.kw}`});
            break;
          default:
            break;
        }
        // switch (val) {
        //   case 0:
        //     this.$router.replace({path:`/Preview/PreNotRegistered?kw=${this.kw}`});
        //     break;
        //   case 1:
        //     this.$router.replace({path:`/Preview/PreEnrolled?kw=${this.kw}`});
        //     break;
        //   default:
        //     break;
        // }
      }
    },
    watch: {
      selected(newVal, oldVal) {
        this.kw = '';
        this.handleRoute(newVal);
      }
    }
}

</script>
<style lang='less' scoped>
.Preview{
    min-height: 100vh;
    width: 100%;
    background: #eee;
    top: 0;
    left: 0;
    .navbar{
      position: fixed;
      // top:0.54rem;
      border-top: 0.52rem solid #eeeeee;
      max-width: 640px;
      background: white;
      width: 100%;
    }
}
</style>